import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const mediaFeedbackStyles = {
	contentWrapper: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		padding: '12px',
		backgroundColor: 'colors.dark6',
		border: `1px solid ${colorPalette.dark4}`,
		borderRadius: '8px',
	},
	inputContainerStyles: {
		marginTop: 0,
		height: '60px',
		minWidth: {
			xs: 'calc(100% - 16px)',
			sm: 'calc(100% - 16px)',
			md: '620px',
		},
		minHeight: '48px',
		backgroundColor: 'colors.dark4',
		padding: '4px 8px',
	},
	inputStyles: {
		padding: '0px',
		color: 'colors.light3',
		fontSize: '12px',
		fontWeight: '400',
		lineHeight: '24px',
	},
	buttonWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',

		position: 'relative',
	},
	submitButton: {
		height: '30px',
		padding: '8px',
		borderRadius: '4px',

		backgroundColor: 'colors.light3',
		textTransform: 'none',

		'&:hover': {
			backgroundColor: 'colors.light3',
		},
		'&.Mui-disabled': {
			backgroundColor: 'colors.dark2',
		},
	},
	closeButton: {
		position: 'absolute',
		top: '12px',
		right: '12px',
		cursor: 'pointer',
		'& svg': {
			width: '20px',
			height: '20px',
		},
	},
	successContainer: {
		alignItems: 'center',
		minWidth: {
			xs: 'calc(100% - 16px)',
			sm: 'calc(100% - 16px)',
			md: '620px',
		},
	},
	checkedIconCont: {
		'& svg': {
			width: '40px',
			height: '40px',
		},
	},
};
